import * as React from 'react';
import * as styles from './styles.scss';
import {
    getCanvasView,
    AssetId,
    AssetViewBase,
    DisableAssetCommandsProvider,
    useViewStateSelectors,
} from 'owa-timestream-asset-sdk';
import { observer } from 'mobx-react-lite';
import BucketDropTarget from './BucketDropTarget';

export default observer(function BucketChildView({
    childId,
    childType,
    childOrder,
    minOrder,
    maxOrder,
}: {
    childId: AssetId;
    childType: string;
    childOrder: number;
    minOrder: number;
    maxOrder: number;
}) {
    const { isMovingAssets, isSelectedAsset } = useViewStateSelectors();
    const isMovingOutOfBucket = isMovingAssets() && isSelectedAsset(childId);
    const className = isMovingOutOfBucket ? styles.bucketChildViewMoving : styles.bucketChildView;

    const CanvasView = getCanvasView(childType);
    return (
        CanvasView && (
            <div className={className}>
                <DisableAssetCommandsProvider value={isMovingOutOfBucket}>
                    {
                        <AssetViewBase
                            assetId={childId}
                            View={CanvasView}
                            assetAttributes={{ className: styles.bucketChild }}
                        />
                    }
                </DisableAssetCommandsProvider>
                <BucketDropTarget
                    activeClassName={styles.topItemActive}
                    hoverClassName={styles.topItemHover}
                    minOrder={minOrder}
                    maxOrder={childOrder - 1}
                />
                <BucketDropTarget
                    activeClassName={styles.bottomItemActive}
                    hoverClassName={styles.bottomItemHover}
                    minOrder={childOrder + 1}
                    maxOrder={maxOrder}
                />
            </div>
        )
    );
});
